import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

import logo from "../../assets/footer-logo.png";

export default function Footer() {
	return (
		<footer className="footer-container">
			<div className="footer-logo">
				<Link to={"/"}>
					<img src={logo} alt="Logo" />
				</Link>
			</div>
			<div className="footer-divider"></div>
			<div className="footer-email-container">
				<p>Contact us:</p>
				<p className="footer-email">
					<a href="mailto:contact@joinparket.com">
						contact@joinparket.com
					</a>
				</p>
			</div>
		</footer>
	);
}
